import { render } from "./SignForm.vue?vue&type=template&id=3157dde8&scoped=true&ts=true"
import script from "./SignForm.vue?vue&type=script&lang=ts"
export * from "./SignForm.vue?vue&type=script&lang=ts"

import "./SignForm.vue?vue&type=style&index=0&id=3157dde8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3157dde8"]])

export default __exports__